// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"883d5e10","845":"78c09d51"}[chunkId] + ".chunk.js";
};